'use es6';

export const FAILED_LOGIN_PAGES = {
  PASSWORD_LEAK: '/password-leak',
  SUSPICIOUS_ACTIVITY: '/suspicious-activity',
  UPDATE_PASSWORD: '/update-password',
  IDLE_USER: 'idle-user',
  SUSPICIOUS_USER_MUST_CONFIRM: '/confirm-to-login'
};